import React, { useEffect } from 'react';
import Routes from './Routes/index';

//import Custom Style scss
import './assets/scss/themes.scss';
import { useSelector } from 'react-redux';

function SignalRApp() {
  const userDetailsToShow = useSelector(
    state => state.user.UserDetailsObj.userInfo
  );
  useEffect(() => {
    if (typeof window !== 'undefined' && window.clarity) {
      // First, reset any previous identity by reloading Clarity
      window.clarity('set', 'userId', null); // optional: clear user ID manually

      // Slight delay to make sure clarity is ready
      setTimeout(() => {
        if (userDetailsToShow?.firstName) {
          window.clarity(
            'identify',
            `${userDetailsToShow.firstName} ${userDetailsToShow.lastName}`,
            {}
          );
        }
      }, 300); // delay to ensure clarity is loaded
    }
  }, [userDetailsToShow]);

  return (
    <div>
      <Routes />
    </div>
  );
}

export default SignalRApp;
